import { render, staticRenderFns } from "./DocumentTemplateListTable.vue?vue&type=template&id=6f00083c&"
import script from "./DocumentTemplateListTable.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports